import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button, InlineNotification, Text } from '@frontend/design-system';
import Footer from '../../../layout/footer.component';
import { buttonContainerStyle, cardStyle, contentContainerStyle } from './filling-option-screen.styles';

interface FillingOptionScreenProps {
  officeName?: string;
  locationId: string;
  onAutoFill: () => void;
  onManualFill: () => void;
}

export const FillingOptionScreen: FC<FillingOptionScreenProps> = ({ onAutoFill, onManualFill }) => {
  const { t } = useTranslation('digital-forms-experience');

  return (
    <>
      <div css={cardStyle}>
        <div css={contentContainerStyle}>
          <Text as='h1' size='large' weight='bold'>
            {t('Save time by auto-filling your information from past form submissions, or fill out the form manually.')}
          </Text>
          <InlineNotification
            status='warn'
            message={t(
              'Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.'
            )}
          />
          <div css={buttonContainerStyle}>
            <Button onClick={onAutoFill} variant='primary' size='large'>
              {t('Auto-fill Form')}
            </Button>
            <Button onClick={onManualFill} variant='secondary' size='large'>
              {t('Fill out Manually')}
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
